import { Enum, EnumType } from 'ts-jenum';

@Enum<EditorType>('value')
export class EditorType extends EnumType<EditorType>() {
   static readonly TEXT_EDITOR = new EditorType('TEXT_EDITOR', 'common.types.editorType.text_edtior');

   static readonly CHECK_BOX = new EditorType('CHECK_BOX', 'common.types.editorType.check_box');

   static readonly RICH_TEXT_EDITOR = new EditorType('RICH_TEXT_EDITOR', 'common.types.editorType.rich_text');

   static readonly NUMBER_EDITOR = new EditorType('NUMBER_EDITOR', 'common.types.editorType.numeric');

   static readonly SELECTOR = new EditorType('SELECTOR', 'common.types.editorType.selector');

   private constructor(public value: string, public translationKey: string) {
      super();
   }
}

export interface IEditorTypeConfiguration {
   CheckboxValue: string;
   IsPlaintextMode: boolean;
   ShowDecimals: boolean;
   ShowThousandSeparator: boolean;
   SelectorValues: string;
}
